import { computed } from "@ember/object";
import { classNames } from "@ember-decorators/component";
import ComboBoxComponent from "select-kit/components/combo-box";
import { pluginApiIdentifiers, selectKitOptions } from "select-kit/components/select-kit";
const FlairChooser = dt7948.c(class FlairChooser extends ComboBoxComponent {
  modifyComponentForRow() {
    return "flair-row";
  }
  get selectedContent() {
    const content = (this.content || []).findBy(this.selectKit.valueProperty, this.value);
    if (content) {
      return this.selectKit.modifySelection(content);
    } else {
      return this.selectKit.noneItem;
    }
  }
  static {
    dt7948.n(this.prototype, "selectedContent", [computed("value", "content.[]", "selectKit.noneItem")]);
  }
}, [pluginApiIdentifiers(["flair-chooser"]), selectKitOptions({
  selectedNameComponent: "selected-flair"
}), classNames("flair-chooser")]);
export default FlairChooser;